export default __webpack_public_path__ + "static/digital-transformation-student-onboarding-81ab3e68d51155b8f2f5d9d65168f95a.jpg";